import { render, staticRenderFns } from "./flats-view-btns.vue?vue&type=template&id=23f3abc4"
import script from "./flats-view-btns.vue?vue&type=script&lang=js"
export * from "./flats-view-btns.vue?vue&type=script&lang=js"
import style0 from "./flats-view-btns.vue?vue&type=style&index=0&id=23f3abc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports